'use client';

import { css, cx } from '@onbeam/business-styled-system/css';
import { center, text } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { ShaderBannerProps } from './ShaderBanner.types';
import { ShaderBannerAnimation } from './ShaderBannerAnimation';
import NextLink from 'next/link';
import { useRef } from 'react';
import { useInView } from 'motion/react';

export const ShaderBanner = ({
  title,
  description,
  className,
  button,
  css: cssProp,
  preset,
}: ShaderBannerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    margin: '500px 0px 500px 0px',
  });

  return (
    <div
      ref={ref}
      className={cx(
        'light',
        css(
          center.raw({
            flexDirection: 'column',
            position: 'relative',
            w: 'full',
            h: '[32.5rem]',
            rounded: 'md',
            textAlign: 'center',
            overflow: 'hidden',
            color: 'mono.primaryFg',
            gap: '6',
            p: '5',
            md: {
              h: '[28.75rem]',
            },
          }),
          cssProp,
        ),
        className,
      )}
    >
      {isInView && <ShaderBannerAnimation preset={preset} />}
      <h2 className={text({ style: 'subtitle-lg' })}>{title}</h2>
      {description && (
        <p className={text({ style: 'body-lg', maxW: '[26.5rem]' })}>
          {description}
        </p>
      )}
      {button && (
        <Button
          as={NextLink}
          href={button.href}
          target={button.isExternal ? '_blank' : '_self'}
          rel="noopener noreferrer"
          variant="secondary"
        >
          {button.text}
        </Button>
      )}
    </div>
  );
};
